// extracted by mini-css-extract-plugin
export var parcelRow = "_uh-0";